import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';
import { FlexRow } from 'ui-components/components/flex';

import { trackShipFromConfigStart, ShipFromTrackingSources } from '../../../../../../ship-from/tracking-events';
import { WAREHOUSES_PATH } from '../../../../../../routes/constants';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';
import { useModal } from '../../../../../../hooks/use-modal';
import ShipFromModal from '../../../../../../ship-from/modals';

import style from '../../onboard-cards.module.less';
import { messages } from '../../messages';
import buttonStyles from 'ui-components/components/button/button-text.module.less';

export const ShipFromCardFooter = () => {
  const { open, close, isOpen } = useModal();
  const { isPopup, isShipFromComplete, closePopupGuide } = useHomePageOnboardContext();
  const onClick = useCallback(() => {
    open();
    trackShipFromConfigStart(isPopup ? ShipFromTrackingSources.GETTING_STARTED_GUIDE : ShipFromTrackingSources.HOME_PAGE_ONBOARDING_STEP);
  }, [isPopup, open]);
  const onSuccess = useCallback(() => {
    close();
    NotificationService.showNotification({
      notificationType: NOTIFICATION_TYPE_SUCCESS,
      title: <FormattedMessage {...messages.saveSuccessMessage} />,
      content: '',
      duration: NOTIFICATION_DURATIONS.MEDIUM,
    });
  }, [close]);
  return isShipFromComplete ? (
    <Link
      className={classnames(style['complete-button'], style['link-button'], buttonStyles['button-text'])}
      onClick={closePopupGuide}
      to={WAREHOUSES_PATH}
    >
      <FormattedMessage {...messages.setShipFromButtonComplete} />
      <FontAwesomeIcon className={style.arrow} icon={faArrowRight} />
    </Link>
  ) : (
    <FlexRow className={style['footer-row']}>
      <Button className={style['footer-row-group']} onClick={onClick} theme='primary'>
        <FormattedMessage {...messages.setShipFromButton} />
      </Button>
      {isOpen && <ShipFromModal onClose={close} onSuccess={onSuccess} />}
    </FlexRow>
  );
};
